import React, { memo } from "react";
import { animated, SpringValue, useTransition } from "react-spring";
import { TecorienLoader } from "../TecorienLoader";

import styles from "./style.module.scss";

type AnimatedDivProps = React.HTMLAttributes<HTMLDivElement> & {
  style?: React.CSSProperties & {
    [key: string]: any;
  };
};

export type FullscreenLoaderProps = {
  processId?: string | number
  description?: string
  progress?: number
}

export const FullscreenLoader = memo<FullscreenLoaderProps>(({ processId, description, progress }) => {
  const transitions = useTransition(!!processId, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: {
      duration: 250,
    },
  });

  const AnimatedDiv = animated("div") as React.ForwardRefExoticComponent<AnimatedDivProps & React.RefAttributes<HTMLDivElement>>;

  return (
    <>
      {
        transitions((props, item) => item && (
          <AnimatedDiv style={props as React.CSSProperties & { opacity?: SpringValue<number>, width?: SpringValue<number>, x?: SpringValue<number> } } className={styles.root}>
            <input className={styles.hiddenInput} autoFocus />
            <div className={styles.background} />
            <div className={styles.content}>
              <TecorienLoader className={styles.loader} description={description} progress={progress} />
            </div>
          </AnimatedDiv>
        ))
      }
    </>
  );
});

export default FullscreenLoader;
